export default (params) => {
    const tourCriteria = {};
    const element = params.fromCity;
    if (element) {
        tourCriteria.departureCity = element;
    }

    return tourCriteria;
};